import React from 'react';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import PropTypes from 'prop-types';

KatalogBarcodeScanner.propTypes = {
  found: PropTypes.func
};

export default function KatalogBarcodeScanner({ found }) {
  return (
    <>
      <BarcodeScannerComponent
        onUpdate={(err, result) => {
          if (result) {
            found(result.text);
          }
        }}
      />
    </>
  );
}
